import React from 'react';

const ParticipantCategory = () => {
  return (
    <iframe
      src="https://iframe.krgsc.kz/participant-category"
      title="participant-category"
      style={{ border: 'none' }}
      width="100%"
      height="100%"
    />
  );
};

export default ParticipantCategory;
